import * as Constants from './Constants';

const initialState = {
  deviceupgradeData: {},
  createCartData: {},
  isLoading: false,
};

function deviceUpgradeDetails(state = initialState, action) {
  switch (action.type) {
    case Constants.START_LOADING:
      return { ...state, isLoading: true };
    case Constants.STOP_LOADING:
      return { ...state, isLoading: false };
    case Constants.DEVICE_UPGRADE_SUCCESS:
      return { ...state, deviceupgradeData: action.response };
    case Constants.DEVICE_UPGRADE_ERROR:
      return { ...state, deviceupgradeData: action };
    case Constants.CREATE_CART_SUCCESS:
      return { ...state, createCartData: action.response };
    case Constants.CREATE_CART_ERROR:
      return { ...state, createCartData: action };
    default:
      return state;
  }
}

export default deviceUpgradeDetails;
